import {Link} from 'react-router-dom'

const NotFound = () => {
  return (
    <div style={{margin:'40px',display: 'flex',justifyContent:'center',color:'blue',
                backgroundColor:'white',padding:'30px 10px',borderRadius:'8px'}}>
        <h2>Sorry , this page does not exist .. return to <Link to='/'> Home </Link></h2>
    </div>
  )
}

export default NotFound